import React, { useState, useMemo, useEffect, useCallback } from "react";
import ReactDOM from "react-dom";
import ChatBot from "react-simple-chatbot";
import api from "services/api";
import { ThemeProvider } from "styled-components";
import { useRouter } from "next/router";
import axios from "axios";
import styles from "./styles.module.css";

const theme = {
  background: "#f5f8fb",
  fontFamily: "DM Sans, sans-serif",
  headerBgColor: "rgb(222, 69, 97)",
  headerFontColor: "#fff",
  headerFontSize: "15px",
  botBubbleColor: "rgb(222, 69, 97)",
  botFontColor: "#fff",
  userBubbleColor: "#fff",
  userFontColor: "#4a4a4a",
};

const cidades = [
  {
    label: "Anápolis - GO",
    value: "anapolis",
  },
  {
    label: "Araguari - MG",
    value: "MG",
  },
  { label: "Campos dos Goytacazes - RJ", value: "RJ" },
  {
    label: "Uberlândia - MG",
    value: "MG",
  },
  {
    label: "Rio Verde - GO",
    value: "rio-verde",
  },
  { label: "Ribeirão Preto - SP", value: "ribeirao-preto" },
  { label: "Aparecida de Goiânia (Garavelo) - GO", value: "garavelo-go" },
];

const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

function Bot({ isSite, produto }) {
  const [showBot, setShowBot] = useState(false);
  const [userData, setUserData] = useState({});
  const router = useRouter();

  const steps = useMemo(
    () => [
      {
        id: 1,
        message:
          "Olá! 👋 Eu sou a Rê, atendente virtual da Realiza Construtora 💁",
        trigger: 2,
        delay: 1000,
      },
      {
        id: 2,
        message:
          "O sonho da sua casa própria está mais próximo do que você imagina! 🤩",
        trigger: 3,
        delay: 2000,
      },
      {
        id: 3,
        message:
          "Estou aqui para te ajudar a fazer uma simulação de financiamento. Vai levar no máximo 2 minutos, vamos lá? ✌️",
        delay: 2000,
        trigger: 4,
      },
      {
        id: 4,
        options: [{ label: "Vamos começar!", value: 1, trigger: 5 }],
      },
      {
        id: 5,
        message: "Qual é o seu nome?",
        trigger: "name",
      },
      {
        id: "name",
        user: true,
        validator: (value) => {
          if (value?.length < 2) {
            return "😰 Ops, você precisa digitar um nome valido!";
          }
          return true;
        },
        trigger: ({ value }) => {
          setUserData({ nome: value });
          return 7;
        },
      },
      {
        id: 7,
        message: "Em qual das cidades abaixo você pretende comprar seu imóvel?",
        trigger: 8,
      },
      {
        id: 8,
        options: [
          {
            label: "Anápolis - GO",
            value: "Anápolis - GO",
            trigger: ({ value }) => {
              setUserData((usr) => ({
                ...usr,
                cidade: value,
              }));
              return 9;
            },
          },
          {
            label: "Araguari - MG",
            value: "Araguari - MG",
            trigger: ({ value }) => {
              setUserData((usr) => ({
                ...usr,
                cidade: value,
              }));
              return 9;
            },
          },
          {
            label: "Campos dos Goytacazes - RJ",
            value: "Campos dos Goytacazes - RJ",
            trigger: ({ value }) => {
              setUserData((usr) => ({
                ...usr,
                cidade: value,
              }));
              return 9;
            },
          },
          {
            label: "Uberlândia - MG",
            value: "Uberlândia - MG",
            trigger: ({ value }) => {
              setUserData((usr) => ({
                ...usr,
                cidade: value,
              }));
              return 9;
            },
          },
          {
            label: "Rio Verde - GO",
            value: "Rio Verde - GO",
            trigger: ({ value }) => {
              setUserData((usr) => ({
                ...usr,
                cidade: value,
              }));
              return 9;
            },
          },
          {
            label: "Ribeirão Preto - SP",
            value: "Ribeirão Preto - SP",
            trigger: ({ value }) => {
              setUserData((usr) => ({
                ...usr,
                cidade: value,
              }));
              return 9;
            },
          },
          {
            label: "Aparecida de Goiânia (Garavelo) - GO",
            value: "Aparecida de Goiânia (Garavelo) - GO",
            trigger: ({ value }) => {
              setUserData((usr) => ({
                ...usr,
                cidade: value,
              }));
              return 9;
            },
          },
        ],
      },
      {
        id: 9,
        message: "Para iniciarmos poderia confirmar seu e-mail?",
        trigger: 10,
        delay: 1000,
      },
      {
        id: 10,
        user: true,
        validator: (value) => {
          if (!emailRegex.test(value)) {
            return "😰 Ops, você precisa digitar um e-mail valido!";
          }
          return true;
        },
        trigger: ({ value }) => {
          setUserData((usr) => ({ ...usr, email: value }));
          return 11;
        },
      },
      {
        id: 11,
        message: "Qual é o número do seu telefone?",
        trigger: 12,
        delay: 1000,
      },
      {
        id: 12,
        user: true,
        validator: (value) => {
          if (isNaN(value)) {
            return "😰 Ops, digite um número!";
          }
          if (String(value).length < 10) {
            return "😰 Ops, mínimo 10 digitos.";
          }
          if (String(value).length > 11) {
            return "😰 Ops, maximo 11 digitos.";
          }
          return true;
        },
        trigger: ({ value }) => {
          setUserData((usr) => ({ ...usr, telefone: value }));
          return 13;
        },
      },
      {
        id: 13,
        message: ({ steps }) => {
          return `${steps.name.value}, você é casado(a) no cartório?`;
        },
        trigger: 14,
        delay: 1000,
      },
      {
        id: 14,
        options: [
          {
            label: "Sim",
            value: "Sim",
            trigger: ({ value }) => {
              setUserData((usr) => ({ ...usr, casado: value }));
              return 15;
            },
          },
          {
            label: "Não",
            value: "Não",
            trigger: ({ value }) => {
              setUserData((usr) => ({ ...usr, casado: value }));
              return 17;
            },
          },
        ],
      },
      {
        id: 15,
        message: "Seu marido/esposa trabalha atualmente?",
        trigger: 16,
        delay: 1000,
      },
      {
        id: 16,
        options: [
          {
            label: "Sim, com carteira assinada",
            value: "Sim, com carteira assinada",
            trigger: ({ value }) => {
              setUserData((usr) => ({ ...usr, casalTrabalha: value }));
              return 17;
            },
          },
          {
            label: "Sim, é autônomo ou tem renda informal",
            value: "Sim, é autônomo ou tem renda informal",
            trigger: ({ value }) => {
              setUserData((usr) => ({ ...usr, casalTrabalha: value }));
              return 17;
            },
          },
          {
            label: "Não está trabalhando",
            value: "Não está trabalhando",
            trigger: ({ value }) => {
              setUserData((usr) => ({ ...usr, casalTrabalha: value }));
              return 17;
            },
          },
        ],
      },
      {
        id: 17,
        message: "Você trabalha atualmente?",
        trigger: 18,
        delay: 1000,
      },
      {
        id: 18,
        options: [
          {
            label: "Sim, com carteira assinada",
            value: "Sim, com carteira assinada",
            trigger: ({ value }) => {
              setUserData((usr) => ({ ...usr, trabalho: value }));
              return 19;
            },
          },
          {
            label: "Sim, sou autônomo(a) ou tenho renda informal",
            value: "Sim, sou autônomo(a) ou tenho renda informal",
            trigger: ({ value }) => {
              setUserData((usr) => ({ ...usr, trabalho: value }));
              return 19;
            },
          },
          {
            label: "Não estou trabalhando",
            value: "Não estou trabalhando",
            trigger: ({ value }) => {
              setUserData((usr) => ({ ...usr, trabalho: value }));
              return 19;
            },
          },
        ],
      },
      {
        id: 19,
        message: ({ steps }) => {
          return `${steps.name.value}, você vai compor renda com mais alguém?`;
        },
        trigger: 20,
        delay: 1000,
      },
      {
        id: 20,
        options: [
          {
            label: "Sim",
            value: "Sim",
            trigger: ({ value }) => {
              setUserData((usr) => ({ ...usr, comporRenda: value }));
              return 22;
            },
          },
          {
            label: "Não",
            value: "Não",
            trigger: ({ value }) => {
              setUserData((usr) => ({ ...usr, comporRenda: value }));
              return 24;
            },
          },
        ],
      },
      {
        id: 22,
        message: "Essa pessoa trabalha atualmente?",
        trigger: 23,
        delay: 1000,
      },
      {
        id: 23,
        options: [
          {
            label: "Sim, com carteira assinada",
            value: "Sim, com carteira assinada",
            trigger: ({ value }) => {
              setUserData((usr) => ({ ...usr, comporRendaPessoa: value }));
              return 24;
            },
          },
          {
            label: "Sim, é autônomo(a) ou tem renda informal",
            value: "Sim, é autônomo(a) ou tem renda informal",
            trigger: ({ value }) => {
              setUserData((usr) => ({ ...usr, comporRendaPessoa: value }));
              return 24;
            },
          },
          {
            label: "Não está trabalhando",
            value: "Não está trabalhando",
            trigger: ({ value }) => {
              setUserData((usr) => ({ ...usr, comporRendaPessoa: value }));
              return 24;
            },
          },
        ],
      },
      {
        id: 24,
        message: "Qual é a sua renda familiar?",
        trigger: 25,
        delay: 1000,
      },
      {
        id: 25,
        options: [
          {
            label: "Até R$ 1.800,00",
            value: "Até R$ 1.800,00",
            trigger: ({ value }) => {
              setUserData((usr) => ({ ...usr, renda: value }));
              return 26;
            },
          },
          {
            label: "Até R$ 2.200,00",
            value: "Até R$ 2.200,00",
            trigger: ({ value }) => {
              setUserData((usr) => ({ ...usr, renda: value }));
              return 26;
            },
          },
          {
            label: "Até R$ 3.000,00",
            value: "Até R$ 3.000,00",
            trigger: ({ value }) => {
              setUserData((usr) => ({ ...usr, renda: value }));
              return 26;
            },
          },
          {
            label: "Até R$ 4.000,00",
            value: "Até R$ 4.000,00",
            trigger: ({ value }) => {
              setUserData((usr) => ({ ...usr, renda: value }));
              return 26;
            },
          },
          {
            label: "Acima de R$ 5.000,00",
            value: "Acima R$ 5.000,00",
            trigger: ({ value }) => {
              setUserData((usr) => ({ ...usr, renda: value }));
              return 26;
            },
          },
        ],
      },
      {
        id: 26,
        message: "Agora falta pouco!",
        trigger: 27,
        delay: 1000,
      },
      {
        id: 27,
        message:
          "Em breve um corretor entrará em contato com você! Obrigada! 😉",
        end: true,
        delay: 1000,
      },
    ],
    [userData]
  );

  const handleCreateContact = useCallback(async () => {
    if (userData?.id) {
      await api.put(`/contatos-chatbots/${userData.id}`, {
        telefone: userData.telefone ? userData.telefone : "",
        casado: userData.casado ? userData.casado : "",
        casalTrabalha: userData.casalTrabalha ? userData.casalTrabalha : "",
        trabalho: userData.trabalho ? userData.trabalho : "",
        comporRenda: userData.comporRenda ? userData.comporRenda : "",
        comporRendaPessoa: userData.comporRendaPessoa
          ? userData.comporRendaPessoa
          : "",
        renda: userData.renda ? userData.renda : "",
      });
    } else if (userData?.nome && userData?.email && userData?.telefone) {
      const { data } = await api.post("/contatos-chatbots", {
        nome: userData.nome,
        email: userData.email,
        cidade: userData?.cidade,
        telefone: userData?.telefone,
        produto: produto
          ? produto
          : isSite
          ? `site - ${router?.asPath}`
          : router?.query?.produto
          ? router.query.produto
          : "",
      });

      await axios.post("https://www.rdstation.com.br/api/1.3/conversions", {
        token_rdstation: "4931c77adfeeadf0b83746c0ec433643",
        identificador: "Simulador Landbot",
        nome: userData?.nome,
        email: userData?.email,
        cidade: cidades.find((cit) => cit.label === userData?.cidade)?.value,
        utm_source: "@utm_source",
        utm_campaign: "@utm_campaign",
        utm_medium: "@utm_medium",
      });

      // const produtos = [
      //   "Simulador Online - anapolis",
      //   "Simulador Online - rio-verde",
      //   "Simulador Online - MG",
      //   "Simulador Online - RJ",
      //   "Simulador Online - garavelo-go",
      //   "Simulador Online - ribeirao-preto",
      // ];

      await axios.post("https://integrate.leadflow.digital/leads", {
        product: `Simulador Online - ${
          cidades.find((cit) => cit.label === userData?.cidade)?.value
        }`,
        name: userData?.nome,
        email: userData?.email,
        telefone: userData?.telefone,
        canal: "bot",
        obs: `Cidade: ${userData?.cidade}`,
      });

      setUserData((urs) => ({ ...urs, id: data.id }));
    }

    // send to rdstation
  }, [userData, router, axios, cidades]);

  const handleEnd = useCallback(() => {
    setUserData({});
  }, []);

  useEffect(() => {
    handleCreateContact();
  }, [userData, router]);

  if (window && document) {
    const getBody = window.parent.document.getElementsByTagName("body");
    // const resetBodyStyle = document.getElementsByTagName("html");

    // resetBodyStyle[0].style.display = "none";

    return (
      <>
        {ReactDOM.createPortal(
          <>
            {showBot && (
              <div className={styles.chatBotBody}>
                <ThemeProvider theme={theme}>
                  <ChatBot
                    headerTitle="Fale com a Rê"
                    bubbleOptionStyle={{
                      background: "#ffffff",
                      color: "#4a4a4a",
                    }}
                    handleEnd={handleEnd}
                    placeholder="Escreva aqui a sua mensagem"
                    botAvatar="/icons/re.jpg"
                    steps={steps}
                  />
                </ThemeProvider>
              </div>
            )}

            <div
              onClick={() => setShowBot(!showBot)}
              className={styles.chatBotIcon}
            >
              {showBot ? (
                <svg
                  style={{ fill: "#fff", height: 17, width: 17 }}
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path d="M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z"></path>
                </svg>
              ) : (
                <img src="/icons/bubble.svg" alt="Realiza construtora" />
              )}
            </div>
          </>,
          getBody[0]
        )}
      </>
    );
  } else return null;
}

export default Bot;
